import { AutocompleteProps } from "@mui/material/Autocomplete";
import { StyledAutocomplete } from "./styled";

const AutocompleteField = (
  props: AutocompleteProps<
    any,
    boolean | undefined,
    boolean | undefined,
    boolean | undefined,
    any
  > & { borderColor?: string },
) => {
  return <StyledAutocomplete {...props} />;
};

export default AutocompleteField;
